// extracted by mini-css-extract-plugin
export default {"title":"ItemChooserModal_title__q0ZWL","content":"ItemChooserModal_content__IIDKV","modal":"ItemChooserModal_modal__ev3MK","longModal":"ItemChooserModal_longModal__ypC1M"};